import React from 'react';

interface IProps {
  email: string;
  badges?: React.ReactNode;
  children?: React.ReactNode;
  onSignOut: () => void;
}

export default function ProfileMenu({ email, badges, children, onSignOut }: IProps) {
  const initial = email?.charAt(0).toUpperCase() ?? '?';
  const avatar = (size: string) =>
    <span className={`avatar ${size} avatar-circle avatar-soft-primary p-0 flex-shrink-0`}>
      <span className="avatar-initials">{initial}</span>
    </span>;

  return (
    <li className="nav-item dropdown d-flex align-items-center">
      <button
        className="btn btn-link border-0 p-0 lh-1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Account menu">
        {avatar('avatar-sm')}
      </button>
      <div data-testid="profile-menu" className="dropdown-menu dropdown-menu-end p-0 overflow-hidden" style={{ minWidth: '17rem' }}>
        <div className="d-flex align-items-center gap-3 p-3 bg-light">
          {avatar('')}
          <div className="text-truncate">
            <div className="fw-semibold text-truncate" title={email}>{email}</div>
            {badges && <div className="d-flex flex-wrap gap-1 mt-1">{badges}</div>}
          </div>
        </div>
        {children}
        <button className="dropdown-item d-flex align-items-center gap-2 py-2 border-top" onClick={onSignOut}>
          <i className="bi-box-arrow-right"></i>
          <span>Sign Out</span>
        </button>
      </div>
    </li>
  );
}
